import { Component, OnInit ,  VERSION} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { DebounceService } from 'src/app/core/services/debounce.service';


// standalone module
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SKU_TAB_OPTIONS } from 'src/app/lib/constants/tabs.constants';
import { SharedComponentsModule } from 'src/app/shared/modules/shared-component.module';
import { MatTooltip } from '@angular/material/tooltip';
@Component({
  selector: 'app-sku-redeem',
  templateUrl: './sku-redeem.component.html',
  styleUrls: ['./sku-redeem.component.scss'],
  standalone: true,
  imports: [
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    ReactiveFormsModule,
    RouterLink,
    SharedComponentsModule,
    MatTooltip,
    CommonModule
  ],
})
export class SkuRedeemComponent implements OnInit {
  public redeemForm: UntypedFormGroup;

  // add SKU
  isDisplay = true;
  toggleDisplay(){
    this.isDisplay =
    !this.isDisplay;
  }
  // tabs
  tabs = SKU_TAB_OPTIONS;
  
  // category
  category: any;
  category_text: any;


  constructor(
    private fb : UntypedFormBuilder,
    public debounce: DebounceService
  ) {
    this.initializeForm();
  }

  ngOnInit(): void {
    const tableHeader = document.getElementsByTagName("th");
    for (let i = 0; i < tableHeader.length; i++) {
      tableHeader[i].classList.add("headerSortDown");
    }
  }
  initializeForm(){
    this.redeemForm = this.fb.group({
      description: [
        '',
        Validators.compose([
          Validators.required
        ])
      ],
    })
  }

  setheader(index){
    localStorage.setItem('navigate', index);
  }

  setCategoryType(text, value){
    this.category = value;
    this.category_text = text;
  }
}
